import { Box, Button } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
const Header = () => {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await signOut();
    navigate("/login");
  };
  return (
    <div className="flex justify-between px-10 pt-5">
      <Box>
        <img src="/images/logo.png" alt="logo" width="200px" />
      </Box>
      <div>
        <Button onClick={() => handleSignOut()}>
          <ExitToAppIcon />
        </Button>
      </div>
    </div>
  );
};
export default Header;
